module.exports = __webpack_public_path__ + "static/media/ico_passportF.35bf0e23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico_passportF.svg
// module id = 1075
// module chunks = 0